import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";
import Icon from "../../../assets/icons/Icon";
import { LiaUserCircleSolid } from "react-icons/lia";
import { TiArrowSortedDown } from "react-icons/ti";

const LogoutCustom = ({ name, onClick }) => {
  return (
    <Dropdown className="d-inline ">
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        className="btn_user_box"
        style={{
          padding: 0,
          background: "none",
          border: "none",
        }}
      >
        <LiaUserCircleSolid fontSize={"22px"} />
        <span>
          {name} <TiArrowSortedDown />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#" onClick={onClick}>
          <Icon name="FaPowerOff" className="fs-18 me-1 align-text-bottom" />
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(LogoutCustom);
